// @flow

import { onclickFunction } from './linkify'

// only exported for unit test
export function replaceBold (text: string): string {
  return text.replace(/\*(.*?)\*/g, '<b>$1</b>')
}

// only exported for unit test
export function replaceLineBreaks (text: string): string {
  return text.replace(/\\n/g, '<br/>')
}

// only exported for unit test
export function replaceItalic (text: string): string {
  return text.replace(/_([^&=]*)_/g, '<i>$1</i>')
}

// only exported for unit test
export function replaceSmall (text: string): string {
  return text.replace(/<small>/g, '<span class="small-text">').replace(/<\/small>/g, '</span>')
}

// only exported for unit test
export function replaceLink (text: string, messageId?: number): string {
  return text.replace(/(?:__|[#])|\[(.+?)]\((.+?)\)/g, (match, p1, p2) => {
    p1 = typeof p1 !== 'string' ? '' : p1
    p2 = typeof p2 !== 'string' ? '' : p2
    p2 = p2.replace(/_/g, '%5F')
    return `<a href="${p2}" target="_blank" onclick="${onclickFunction(p2, messageId)}">${p1}</a>`
  })
}

function getRandomInt (max: number) {
  return Math.floor(Math.random() * max)
}

// only exported for unit test
export function replaceCollapsible (text: string): string {
  const id = `checkbox-collapsible-${getRandomInt(1000)}`
  return text.replace(/<collapsible title="(.+?)">(.+?)<\/collapsible>/gs,
    '<div class="collapsible">' +
    `<input type="checkbox" id="${id}" name="rd">` +
    `<label class="collapsible-label" for="${id}">$1</label>` +
    '<div class="collapsible-content">$2</div>' +
    '</div>')
}
